<script setup lang="ts">
import * as v from 'valibot'

definePageMeta({
  name: 'fallback',
})

const route = useRoute<'fallback'>()

const slug = computed(() => route.params.slug ?? [])

const { data, error } = await useAsyncGql('GetCanonicalPath', {
  language: CRYSTALLIZE_LANGUAGE,
  path: computed(() => `/${slug.value.join('/')}`),
  version: useCrystallizeVersion(),
})

if (error.value) {
  throw createError(error.value)
}

if (data.value?.catalogue) {
  const { paths, component } = data.value.catalogue

  const name =
    component?.content && 'text' in component.content && component.content.text

  // FIXME: Workaround until products have proper path handling
  if (paths?.canonical?.startsWith('/aunivers') && name) {
    await navigateTo(`/produktkatalog/${slugify(name)}`, {
      redirectCode: 302,
    })
  } else {
    await navigateTo(data.value?.catalogue?.paths?.canonical, {
      redirectCode: 301,
    })
  }
} else {
  const isbn = slug.value.join('/')
  if (import.meta.server && isValidIsbn(isbn)) {
    const config = useRuntimeConfig()
    // The client library is quite big, so we only import it on the server
    const { createClient } = await import('@crystallize/js-api-client')
    const client = createClient(config.crystallize)

    const query = `
      query GetVariant {
        product {
          variants: getVariants(
            skus: ["${isbn}"]
            language: "no-nb"
            tenantId: "${config.crystallize.tenantId}",
            versionLabel: ${useCrystallizeVersion()}
          ) {
            product {
              shape {
                identifier
              }
              tree {
                path
              }
            }
          }
        }
      }
    `

    const schema = v.object({
      product: v.object({
        variants: v.array(
          v.object({
            product: v.object({
              shape: v.object({
                identifier: v.string(),
              }),
              tree: v.object({
                path: v.string(),
              }),
            }),
          }),
        ),
      }),
    })

    try {
      const data = v.safeParse(schema, await client.pimApi(query))

      if (data.success) {
        const variant = data.output.product.variants[0]

        if (variant) {
          const { shape, tree } = variant.product

          if (shape.identifier === 'default-product') {
            await navigateTo(`${tree.path}#${isbn}`, {
              redirectCode: 301,
            })
          }
        }
      }
    } catch (e) {
      handleError(e, 'Failed to call PIM API')
    }
  }

  throw createError({
    status: 404,
    fatal: true,
  })
}
</script>

<template>
  <div />
</template>
